import {Injectable, Injector} from '@angular/core';

/**
 * Holder for the application `Injector`, so plain (non-DI) classes — DTO/`*_Create` model helpers, static
 * factories — can reach services without being constructed by Angular.
 *
 * **This lives in its own module on purpose: `app.config.ts` cannot be imported from a leaf.**
 * `app.config.ts` pulls in `app.routes.ts`, which pulls in essentially every routed component, so any model
 * file importing `App` from there closes an import cycle back onto those components
 * (`…_Create` → `app.config` → `app.routes` → `items.component` → `interchangeable-group-attached-widget`
 * → `…_Create`). ES modules resolve such a cycle by handing out a partially-initialised module, and the
 * loser is whichever `@Component` decorator runs first: one of its `imports` entries is silently
 * `undefined`, which surfaces far away as `Cannot read properties of undefined (reading 'ɵcmp')` — and only
 * when the bundle's module order happens to enter the cycle from the wrong end, i.e. it appears and
 * disappears as unrelated files are added.
 *
 * `app.config.ts` re-exports `App` so existing importers keep working; **new code should import it from
 * here.**
 */
@Injectable({
  providedIn: 'root'
})
export class App {
  static Injector: Injector;

  constructor(private injector: Injector) {
    App.Injector = injector;
  }
}
